import { gql } from '@apollo/client';

export const FIELD_DECIMAL_PLACES_CONFIG_QUERY = gql`
  query fieldDecimalPlacesConfig {
    fieldDecimalPlacesConfig {
      fieldType
      decimalPlaces
      maxDecimalPlaces
      displayName
    }
  }
`;
